import { Future } from "./async";


let sceneRenderHandlers: CallableFunction[] = [];
let sceneArgs: any[][] = [];
let sceneUpdate: Future<null> = new Future();
let sceneCleanupHandlers: CallableFunction[][] = [];
let scenePreChangeHandlers: CallableFunction[] = [];
let sceneChangeHandlers: CallableFunction[] = [];


export function setScene(handler: CallableFunction, ...args: any[]) {
    if (sceneRenderHandlers.length == 0) {
        sceneRenderHandlers = [handler];
        sceneArgs = [args];
        sceneCleanupHandlers = [[]];
    } else {
        sceneRenderHandlers.pop();
        sceneArgs.pop();
        sceneCleanupHandlers.pop();
        sceneRenderHandlers.push(handler);
        sceneArgs.push(args);
        sceneCleanupHandlers.push([]);
    }
    sceneUpdate.resolve(null);
}


export function addScene(handler: CallableFunction, ...args: any[]) {
    sceneRenderHandlers.push(handler);
    sceneArgs.push(args);
    sceneCleanupHandlers.push([]);
    sceneUpdate.resolve(null);
}


export function reloadScene() {
    sceneUpdate.resolve(null);
}


export function endScene() {
    sceneRenderHandlers.pop();
    sceneArgs.pop();
    sceneCleanupHandlers.pop();
    sceneUpdate.resolve(null);
}


export function registerScenePreChangeHandler(handler: CallableFunction) {
    scenePreChangeHandlers.push(handler);
}


export function registerSceneChangeHandler(handler: CallableFunction) {
    sceneChangeHandlers.push(handler);
}


export function registerCleanupHandler(handler: CallableFunction) {
    sceneCleanupHandlers[sceneCleanupHandlers.length - 1].push(handler);
}


export async function run(rootContainer: HTMLElement, autoClear: boolean) {
    let sceneContainer = rootContainer;
    while (true) {
        sceneUpdate = new Future();
        if (sceneRenderHandlers.length == 0) {
            await sceneUpdate;
            continue;
        }
        const renderHandler = sceneRenderHandlers[sceneRenderHandlers.length - 1];
        const args = sceneArgs[sceneArgs.length - 1];
        const cleanupHandlers = sceneCleanupHandlers[sceneCleanupHandlers.length - 1];
        cleanupHandlers.splice(0, cleanupHandlers.length);
        if (autoClear) {
            sceneContainer.innerHTML = "";
        }
        for (const handler of scenePreChangeHandlers) {
            handler(sceneContainer);
        }
        await renderHandler(sceneContainer, ...args);
        for (const handler of sceneChangeHandlers) {
            handler(sceneContainer);
        }
        await sceneUpdate;
        for (const cleanupHandler of cleanupHandlers) {
            cleanupHandler();
        }
    }
}
